import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutMasonry',
  setup(__props) {

const grid = ref<HTMLDivElement | null>(null);

/**
 * ...
 *
 * @param item ...
 */
function onItemMounted(item: HTMLDivElement) {
  if (!grid.value) return;

  const rowHeight = parseInt(
    window.getComputedStyle(grid.value).getPropertyValue('grid-auto-rows'),
  );

  const rowGap = parseInt(
    window.getComputedStyle(grid.value).getPropertyValue('grid-row-gap'),
  );

  const itemInner = item.querySelector(':scope > div');

  if (!itemInner) return;

  const rowSpan = Math.ceil(
    (itemInner.getBoundingClientRect().height + rowGap) / (rowHeight + rowGap),
  );

  // console.log({ rowHeight, rowGap, rowSpan });

  item.style.gridRowEnd = `span ${rowSpan}`;
}

return { __sfc: true,grid, onItemMounted }
}

})